import Group from "./group";
import pageStyle from "./index.module.less";
import { config as routeConfig } from "@/router";
import { parse } from "./utils";
export default {
    name: "Menu",
    components: { Group },
    data() {
        const list = parse(routeConfig);
        return {
            pageStyle,
            list,
            hide: {}
        };
    },
    created() {
        window.toggleMenuHide = key => {
            this.hide[key] = !this.hide[key];
        };
    },
    props: { onClick: Function },
    computed: {
        active() {
            return this.$route.path.slice(1);
        }
    }
};
